import asyncActionType from "../../utils/asyncActionType";

export const FETCH_CURRENT_USER = asyncActionType("FETCH_CURRENT_USER");
